<script>
import Loading from '@/components/Loading.vue'
import { EventBus, Topics, Types } from '@/event-bus'
import { getHourMinutesSeconds } from '@/utils/dateutils'
import http from '@/utils/http'

export default {
  name: 'EtaMedicao',
  components: { Loading },
  data() {
    return {
      etaId: null,
      eta: null,
      loading: true,
      periodicidade: 'DIARIO',
      periodicidadeMap: {
        DIARIO: { label: 'diário', value: 'DIARIO' },
        SEMANAL: { label: 'semanal', value: 'SEMANAL' },
      },
      now: new Date(),
      nowListener: null,
      coletaParametroValueMap: {},
      salvarDialog: false,
      alertDadosIncompletos: false,
      jaFoiEnviadoComErro: false,
    }
  },
  watch: {
    coletaParametroValueMap: {
      // eslint-disable-next-line no-unused-vars
      handler: function (newVal, oldVal) {
        this.$store.commit('setEtaMedicaoTemp', {
          etaId: this.etaId + this.periodicidade,
          value: newVal,
        })
      },
      deep: true,
    },
  },
  async beforeMount() {
    this.etaId = this.$route.params.etaId
    this.periodicidade = this.$route.params.periodicidade
    await this.loadData()

    this.coletaParametroValueMap =
      this.$store.state.etaMedicao[this.etaId + this.periodicidade] || {}

    this.nowListener = setInterval(() => {
      this.now = new Date()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.nowListener)
  },
  methods: {
    getHourMinutesSeconds,
    async loadData() {
      this.loading = true

      await this.buscarEta()

      this.loading = false
    },
    async buscarEta() {
      await http.eta.get(`eta/${this.etaId}`).then((data) => {
        this.eta = data
      })
    },
    getPontoColetaParametros(ponto) {
      const copyList = [...ponto.coletaParametros].filter(
        (e) => e.periodicidade === this.periodicidade
      )

      copyList.sort((a, b) => a.tipo.localeCompare(b.tipo))

      return copyList
    },
    async enviarMedicao() {
      this.loading = true
      this.salvarDialog = false

      const response = await http.eta
        .post(
          `eta/${this.etaId}/salvar-medicoes`,
          {
            periodicidade: this.periodicidade,
            coletaParametros: { ...this.coletaParametroValueMap },
            validate: !this.jaFoiEnviadoComErro,
          },
          true
        )
        .finally(() => {
          this.loading = false
        })

      if (response === null) {
        this.jaFoiEnviadoComErro = true
        return
      }

      // Clear
      this.$store.commit('setEtaMedicaoTemp', {
        etaId: this.etaId + this.periodicidade,
        value: {},
      })

      EventBus.$emit(Topics.NOTIFICATIONS, {
        message: 'Medição salva com sucesso',
        type: Types.INFO,
      })

      this.$router.back()
    },
    verificaEnvio() {
      for (const ponto of this.eta.pontosColeta) {
        for (const coletaParametro of this.getPontoColetaParametros(ponto)) {
          if (this.isVariavelValid(coletaParametro) === false) {
            this.alertDadosIncompletos = true
            return
          }
        }
      }

      this.salvarDialog = true
    },
    pontosColetaPeriodo(eta) {
      const pontosColeta = []

      for (const pontosColetaElement of eta.pontosColeta) {
        const coletaParametros = pontosColetaElement.coletaParametros.filter(
          (e) => e.periodicidade === this.periodicidade
        )

        if (coletaParametros.length > 0) {
          pontosColeta.push(pontosColetaElement)
        }
      }

      pontosColeta.sort((a, b) => a.nome.localeCompare(b.nome))

      return pontosColeta
    },
    isVariavelValid(tipo) {
      if (tipo.topico === 'OPERACAO') {
        return true
      }

      return (
        this.coletaParametroValueMap[tipo.id] !== undefined ||
        this.coletaParametroValueMap[tipo.id] !== '' ||
        this.coletaParametroValueMap[tipo.id] !== null
      )
    },
    shouldShowError(tipo) {
      if (tipo.topico === 'OPERACAO') {
        return false
      }

      return (
        this.coletaParametroValueMap[tipo.id] === undefined ||
        this.coletaParametroValueMap[tipo.id] === '' ||
        this.coletaParametroValueMap[tipo.id] === null
      )
    },
  },
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col-4">
        <div class="row" style="align-items: baseline">
          <div class="hover-cursor ml-2 hover-cursor" @click="$router.back()">
            <md-icon class=""> arrow_back </md-icon>
          </div>
          <div class="ml-3">
            <h1 class="md-title mb-1">
              Nova medição | Coleta {{ periodicidadeMap[periodicidade].label }}
            </h1>
            <p class="mt-0 md-caption" style="font-size: 1rem">
              {{ eta === null ? 'Carregando...' : 'ETA - ' + eta.nome }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-8">
        <div class="row justify-end pr-5" style="justify-content: flex-end">
          <div class="horario">
            <md-icon style="color: #7b1fa2"> schedule </md-icon>
            <span class="pl-2" style="font-weight: bold">
              {{ getHourMinutesSeconds(now) }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="pl-4">
      <loading :loading="loading" />
      <div v-if="!loading">
        <div v-for="ponto in pontosColetaPeriodo(eta)" :key="ponto.id">
          <p class="md-title">
            {{ ponto.nome }}
          </p>
          <table>
            <tr>
              <th
                v-for="tipo in getPontoColetaParametros(ponto)"
                :key="tipo.tipo"
              >
                {{ tipo.tipo }}
              </th>
            </tr>
            <tr>
              <td
                v-for="tipo in getPontoColetaParametros(ponto)"
                :key="tipo.tipo"
              >
                <input
                  v-model.number="coletaParametroValueMap[tipo.id]"
                  class="table-input"
                  :class="{ 'table-input-error': shouldShowError(tipo) }"
                  type="number"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div v-if="!loading" class="ml-4 mr-5">
      <div class="row" style="flex-direction: row-reverse">
        <md-button class="md-primary md-raised" @click="() => verificaEnvio()">
          Salvar Medição
        </md-button>

        <md-button @click="() => $router.back()"> Cancelar </md-button>
      </div>
    </div>

    <md-dialog-alert
      :md-active.sync="alertDadosIncompletos"
      md-content="Your post has been deleted!"
      md-confirm-text="Cool!"
    />

    <md-dialog-alert
      :md-active.sync="alertDadosIncompletos"
      md-title="Dados incompletos"
      md-content="Verifique que todos os campos estão preenchidos corretamente"
    />

    <md-dialog-confirm
      :md-active="salvarDialog"
      :md-title="
        jaFoiEnviadoComErro ? 'Salvar medição REVISADA' : 'Salvar medição'
      "
      md-content="Deseja realmente salvar esta medição? essa ação não pode ser desfeita."
      md-confirm-text="Enviar"
      md-cancel-text="Cancelar"
      @md-cancel="salvarDialog = false"
      @md-confirm="enviarMedicao()"
    />
  </div>
</template>

<style scoped lang="scss">
table,
th,
td {
  border: 1px solid #b9b9b9;
  border-collapse: collapse;
}

th {
  padding: 15px;
  text-align: left;
  width: 10vw;
  height: 7vh;
  background-color: #ededed;
  color: #74747b;
  font-size: 1rem;
}

td {
  text-align: left;
  width: 10vw;
  height: 7vh;
  background-color: #f9f9f9;
  color: #74747b;
  font-size: 1rem;
}

.table-input {
  border: 0;
  font-size: 1rem;
  height: 100%;
  width: 100%;
}

.table-input-error {
  border: 1px solid red;
}

.horario {
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  background-color: #f2e9f6;
  color: #7b1fa2;
}
</style>
